import { ETipoCobertura } from "./tipoCoberturas";

const RC = ETipoCobertura.RC;
const TC = ETipoCobertura.TCBase;
const TP = ETipoCobertura.TCPremium;
const TR = ETipoCobertura.TR;

export { RC, TC, TP, TR };
